const calendarHu = {
    "weekdays": {
        "shorthand": {
            "0": "Vas",
            "1": "Hét",
            "2": "Ke",
            "3": "Sze",
            "4": "Csü",
            "5": "Pén",
            "6": "Szo"
        },
        "longhand": {
            "0": "Vasárnap",
            "1": "Hétfő",
            "2": "Kedd",
            "3": "Szerda",
            "4": "Csütörtök",
            "5": "Péntek",
            "6": "Szombat"
        }
    },
    "months": {
        "shorthand": {
            "0": "Jan",
            "1": "Feb",
            "2": "Már",
            "3": "Ápr",
            "4": "Máj",
            "5": "Jún",
            "6": "Júl",
            "7": "Aug",
            "8": "Sze",
            "9": "Okt",
            "10": "Nov",
            "11": "Dec"
        },
        "longhand": {
            "0": "Január",
            "1": "Február",
            "2": "Március",
            "3": "Április",
            "4": "Május",
            "5": "Június",
            "6": "Július",
            "7": "Augusztus",
            "8": "Szeptember",
            "9": "Október",
            "10": "November",
            "11": "December"
        }
    },
    hour: "óra",
    minute: "perc",
}

export default calendarHu;